import {InjectionToken} from '@angular/core';
import {UserRole} from '../enums/user-role';

export interface RouteRedirects {
    LOGIN_ROUTE: string;
    DASHBOARD_ROUTES: {[userRole in UserRole]: string};
    GUEST_START_PAGE?: string;
}

/**
 * [HED-934] Support guest user.
 */
export const getGuestStartPageUrl = (routeRedirects: RouteRedirects): string => {
    let url: string = routeRedirects.GUEST_START_PAGE;

    if (!url) {
        console.warn('GUEST_START_PAGE is not defined, while the guest is allowed.');
        url = routeRedirects.DASHBOARD_ROUTES[UserRole.TRADER];
    }

    return url;
};

export const ROUTE_REDIRECTS_TOKEN = new InjectionToken<RouteRedirects>('ROUTE_REDIRECTS');
